import {
    CDLGB_URL,
    CDINC_URL,
    TORGB_URL,
    TORAU_URL,
    FCGGB_URL,
    CDLZA_URL
} from '../Constants/Constants';

export const getPolicyURLBasedOnLegalEntity = (legalEntity) => {
    const POLICY_URL_SELECTOR = {
        CDLGB: CDLGB_URL,
        CDINC: CDINC_URL,
        CDLZA: CDLZA_URL,
        TORGB: TORGB_URL,
        TORAU: TORAU_URL,
        FCGGB: FCGGB_URL
    };

    return POLICY_URL_SELECTOR[legalEntity];
};